import MaterialTable from 'material-table';
import React from 'react';
import { Box } from '../../UI';
import tableIcons from '../../UI/icons';
import { IconButton, Menu, MenuItem } from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';
import { Link } from 'react-router-dom';
import MenuIcon from '@material-ui/icons/Menu';
import './style.css'

const Action = ({ id }) => {
	const [anchorEl, setAnchorEl] = React.useState(null);
	const isMenuOpen = Boolean(anchorEl);
	const handleMenuClose = () => {
		setAnchorEl(null);
	};
	const handleProfileMenuOpen = event => {
		setAnchorEl(event.currentTarget);
	};
	const menuId = 'primary-search-account-menu';
	const renderMenu = (
		<Menu
			anchorEl={anchorEl}
			anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
			id={menuId}
			keepMounted
			transformOrigin={{ vertical: 'top', horizontal: 'right' }}
			open={isMenuOpen}
            onClose={handleMenuClose}
		>
            <MenuItem onClick={handleMenuClose}>View</MenuItem>
			<MenuItem onClick={handleMenuClose}>Q&A</MenuItem>
			<MenuItem onClick={handleMenuClose}>
				<Link to={`/my-portfolio/${id}/loi-summary`} style={{ color: 'inherit', textDecoration: 'none' }}>
					Exclusivity
				</Link>
			</MenuItem> 
		</Menu>
	);
    return (
        <>
            <Tooltip title="Saul Hudson" aria-label="account">
                <IconButton
                    edge="end"
                    color="inherit"
                    aria-label="menu"
                    aria-controls={menuId}
                    aria-haspopup="true"
                    onClick={handleProfileMenuOpen}
                    color='primary'
                >
                    <MenuIcon />
                </IconButton>
            </Tooltip>
            {renderMenu}
        </>
    )
}

class Editable extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			columns: [
                { title: '#', field: 'id' },
                { title: 'Bidder', field: 'bidder' },
                { title: 'Bidder Type', field: 'bidderType' },
                { title: 'System Ranking', field: 'systemRanking' },
                { title: 'Bid Value', field: 'bidValue', type: 'numberic' },
                { title: 'Bid Cap Rate', field: 'bidCapRate', type: 'numeric' },
                { title: 'Actions', render: () => <Action id={this.props.id} /> }
            ],
			data: [
                {
                    id: 1,
                    bidder: 'AM001',
                    bidderType: '',
                    systemRanking: 2,
                    bidValue: '£180,000,000',
                    bidCapRate: '10%'
                },
                {
                    id: 2,
                    bidder: 'AM002',
                    bidderType: '',
                    systemRanking: 1,
                    bidValue: '£200,000,000',
                    bidCapRate: '20%'
                },
                {
                    id: 3,
                    bidder: 'AM003',
                    bidderType: '',
                    systemRanking: 4,
                    bidValue: '£150,000,000',
                    bidCapRate: '15%'
                },
                {
                    id: 4,
                    bidder: 'AM004',
                    bidderType: '',
                    systemRanking: 3,
                    bidValue: '£170,000,000',
                    bidCapRate: '5%'
                }
            ],
		};
	}

	render() {
		return (
			<Box mt="15px">
				<MaterialTable
					icons={tableIcons}
					options={{ padding: 'dense', tableLayout: 'auto' }}
					title=""
					columns={this.state.columns}
                    data={this.state.data}
                    style={{padding: '15px'}}
				/>
			</Box>
		);
	}
}

export default Editable;
